<div class="notification-toast" *ngIf="showToast">
    <div class="toast-container">
        <div [ngClass]="toastIconCss[toastType]">
            <img [src]="toastIcon[toastType] | asset">
        </div>
        <div class="notification-toast__content">
            <div class="notification-title">{{translationToastMessage['toastMessage.'+toastType]}}</div>
            <div class="notification-description">
                {{desciption}}
            </div>
            <div class="error-code" *ngIf="errorCode">
                Error code {{errorCode}}
            </div>
        </div>
        <div class="toast-close">
            <img [src]="'cancelIcon' | asset" (click)="closeToast()">
        </div>
    </div>
</div>
